export const rawRevision = {
    revision: 1,
    createdAt: '2023-01-01T00:00:00Z',
    updatedAt: '2023-01-01T00:00:00Z',
    etag: '',
};
//# sourceMappingURL=raw-revision.js.map